import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { fetchRecord, RECORD_FIELDS } from '../recordsApi';
import { useAsync } from '../hooks';
import RecordMedia from '../components/RecordMedia';

const BackLink = () => (
  <Link to="/listings" className="rec-btn rec-back">
    <span aria-hidden="true">←</span> Back to listings
  </Link>
);

export default function RecordShow() {
  const { id } = useParams();
  const { data: record, loading, error } = useAsync(() => fetchRecord(id), [id]);

  return (
    <div className="rec rec-page rec-narrow">
      <BackLink />

      {loading && <p className="rec-muted rec-sm">Loading…</p>}
      {error && <p className="rec-error rec-sm">Failed to load listing: {error.message}</p>}
      {record === null && <p className="rec-muted rec-sm">Listing {id} was not found.</p>}

      {record && (
        <>
          <div className="rec-header">
            <div>
              <h1>{record.Address__c}</h1>
              <p className="rec-muted rec-sm rec-subtitle">Daft ID {record.DaftId__c}</p>
            </div>
            <Link to={`/listings/${encodeURIComponent(record.DaftId__c)}/edit`} className="rec-btn-primary">
              Edit
            </Link>
          </div>

          <RecordMedia record={record} />

          <dl className="rec-dl">
            {[{ key: 'DaftId__c', label: 'Daft ID' }, ...RECORD_FIELDS].map((f) => (
              <div key={f.key} className="rec-dl-row">
                <dt>{f.label}</dt>
                <dd>
                  {f.key === 'DaftUrl__c' && record.DaftUrl__c ? (
                    <a href={record.DaftUrl__c} target="_blank" rel="noreferrer">{record.DaftUrl__c}</a>
                  ) : (
                    String(record[f.key] ?? '—')
                  )}
                </dd>
              </div>
            ))}
          </dl>
        </>
      )}
    </div>
  );
}
